import { legacy_createStore as createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import rootReducer from "../reducers";
import * as socketClient from "../realtime/socketClient";
import { registerSocketListeners } from "../realtime/socketListeners";
import { attachSessionPersistence } from "../offline/persistSession";
import { attachSoundSync } from "../actions/soundSyncActions";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(preloadedState, socket = socketClient) {
  const store = createStore(rootReducer, preloadedState, composeEnhancers(applyMiddleware(thunk)));

  registerSocketListeners(socket, store.dispatch);
  attachSessionPersistence(store); // keeps the session on the device for offline use
  attachSoundSync(store); // hosts re-broadcast their selection by sound when it changes

  return store;
}
